import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FeatureHeatmap = ({ data }) => {
  const [selectedFeature, setSelectedFeature] = useState(null);

  const getIntensityColor = (value) => {
    if (value >= 80) return 'bg-success';
    if (value >= 60) return 'bg-primary';
    if (value >= 40) return 'bg-warning';
    if (value >= 20) return 'bg-accent';
    return 'bg-muted';
  };

  const getIntensityOpacity = (value) => {
    return `opacity-${Math.floor(value / 20) * 20}`;
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-foreground">Feature Usage Heatmap</h3>
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2 text-xs caption">
            <span className="text-muted-foreground">Low</span>
            <div className="flex gap-1">
              {[20, 40, 60, 80, 100]?.map(val => (
                <div
                  key={val}
                  className={`w-4 h-4 rounded ${getIntensityColor(val)} ${getIntensityOpacity(val)}`}
                />
              ))}
            </div>
            <span className="text-muted-foreground">High</span>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {data?.map((category) => (
          <div key={category?.category} className="card">
            <div className="flex items-center gap-3 mb-4">
              <Icon name={category?.icon} size={20} className="text-primary" />
              <h4 className="font-semibold text-foreground">{category?.category}</h4>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
              {category?.features?.map((feature) => (
                <button
                  key={feature?.name}
                  onClick={() => setSelectedFeature(feature)}
                  className={`p-3 rounded-lg transition-all duration-250 ${getIntensityColor(feature?.usage)} ${getIntensityOpacity(feature?.usage)} hover:scale-105 hover:shadow-md`}
                >
                  <div className="text-xs font-medium text-foreground mb-1">
                    {feature?.name}
                  </div>
                  <div className="text-lg font-bold text-foreground font-data">
                    {feature?.usage}%
                  </div>
                  <div className="text-xs text-foreground/80 caption">
                    {feature?.users?.toLocaleString()} users
                  </div>
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
      {selectedFeature && (
        <div className="card bg-primary/5 border-primary/20">
          <div className="flex items-start justify-between mb-4">
            <div>
              <h4 className="text-lg font-semibold text-foreground mb-2">
                {selectedFeature?.name}
              </h4>
              <p className="text-sm text-muted-foreground">
                {selectedFeature?.description}
              </p>
            </div>
            <button
              onClick={() => setSelectedFeature(null)}
              className="p-2 rounded-lg hover:bg-muted/50 transition-smooth"
            >
              <Icon name="X" size={16} />
            </button>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div>
              <div className="text-xs text-muted-foreground caption mb-1">Usage Rate</div>
              <div className="text-xl font-bold text-foreground font-data">
                {selectedFeature?.usage}%
              </div>
            </div>
            <div>
              <div className="text-xs text-muted-foreground caption mb-1">Active Users</div>
              <div className="text-xl font-bold text-foreground font-data">
                {selectedFeature?.users?.toLocaleString()}
              </div>
            </div>
            <div>
              <div className="text-xs text-muted-foreground caption mb-1">Avg. Frequency</div>
              <div className="text-xl font-bold text-foreground font-data">
                {selectedFeature?.frequency}x/day
              </div>
            </div>
            <div>
              <div className="text-xs text-muted-foreground caption mb-1">Satisfaction</div>
              <div className="text-xl font-bold text-success font-data">
                {selectedFeature?.satisfaction}/5
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FeatureHeatmap;